// import { toast } from 'react-toastify';
import hotToast from 'react-hot-toast';
type NotifyInputType = {
    message: string,
    type: "info" | "warning" | "success" | "error" | "default",
    displayTime?: number

}

export const showNotify = (props: NotifyInputType) => {
    switch (props.type) {
        case "success":
            hotToast.success(props.message)
            break;
        default:
            hotToast.error(props.message);
    }
   
}

export const showHotToast = (props: any) => {
    hotToast(props.message, {
        duration: 30000,
        // position: 'top-center',
        position: 'bottom-right',

        // type: "success",

        // Styling
        style: {},
        className: '',

        // Custom Icon
        icon: '👏',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });
}

export const NotifyHelper = {
    //https://react-hot-toast.com/docs/toast
    Success: (message: string) => hotToast.success(message),
    Error: (message: string) => hotToast.error(message),
    Warning: (message: string) => hotToast.error(message)

    // Success: (message: string) => showNotify({ message: message, type: "success" }),
    // Error: (message: string) => showNotify({ message: message, type: "error" }),
    // Warning: (message: string) => showNotify({ message: message, type: "warning" })
}